import React from 'react'
import axios from 'axios'
import _ from 'underscore'
import { ChevronDown, ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

// Lets staff drop a pre-written, static block of text into the email body.
// Unlike templates, canned replies have no merge tags and are inserted at the
// cursor client-side — no API round trip on select. Managed on the admin portal.
class SelectCannedReply extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      replies: [],
      manage_url: null,
      loaded: false
    }
  }

  componentDidMount() {
    axios.get('/api/sales/canned_replies')
    .then((response) => {
      this.setState({
        replies: response.data.canned_replies || [],
        manage_url: response.data.manage_url || null,
        loaded: true
      })
    })
    .catch((error) => {
      handleError(error)
    })
  }

  onReplyClick = (reply) => {
    this.props.onSelect(reply.body)
  }

  onManageClick = () => {
    if (this.state.manage_url) {
      window.open(this.state.manage_url, '_blank')
    }
  }

  render() {
    const replies = this.state.replies

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button type="button" variant="outline" size="sm">
            Canned reply <ChevronDown className="size-3.5"/>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="max-h-(--radix-dropdown-menu-content-available-height) w-[480px] max-w-[calc(100vw-2rem)] overflow-y-auto">
          {replies.length === 0 &&
            <span className="block px-2 py-1.5 text-sm text-muted-foreground">{this.state.loaded ? 'No canned replies yet' : 'Loading…'}</span>
          }
          {_.map(replies, (reply) => {
            return (
              <DropdownMenuItem key={reply.id} onSelect={() => this.onReplyClick(reply)}>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold">{reply.name}</div>
                  <div className="truncate text-xs text-muted-foreground">{reply.body}</div>
                </div>
              </DropdownMenuItem>
            )
          })}
          {this.state.manage_url &&
            <React.Fragment>
              <DropdownMenuSeparator/>
              <DropdownMenuItem onSelect={this.onManageClick}>
                <ExternalLink className="size-3.5"/> Manage canned replies
              </DropdownMenuItem>
            </React.Fragment>
          }
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }
}

export default SelectCannedReply
